module.exports = {
  MRD_DENEST_IMPC_MAPPING_ADD_REQUEST: 'MRD_DENEST_IMPC_MAPPING_ADD_REQUEST',
  MRD_DENEST_IMPC_MAPPING_ADD_SUCCESS: 'MRD_DENEST_IMPC_MAPPING_ADD_SUCCESS',
  MRD_DENEST_IMPC_MAPPING_ADD_FAILURE: 'MRD_DENEST_IMPC_MAPPING_ADD_FAILURE',
  MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST: 'MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST',
  MRD_DENEST_IMPC_MAPPING_DEACTIVATE_SUCCESS: 'MRD_DENEST_IMPC_MAPPING_DEACTIVATE_SUCCESS',
  MRD_DENEST_IMPC_MAPPING_DEACTIVATE_FAILURE: 'MRD_DENEST_IMPC_MAPPING_DEACTIVATE_FAILURE',
};
